import React, { useMemo } from 'react';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';
import i18n               from 'i18next';

import RenderButton            from '../../buttons/base/RenderButton';
import { RenderEmailField }    from '../../fields/redux/RenderEmailField';
import { RenderPasswordField } from '../../fields/redux/RenderPasswordField';
import { RenderCheckboxField } from '../../fields/redux/RenderCheckboxField';

import { useCommon } from '../../../providers/common';

const RegisterForm = (props) => {
  const {
          changeTab,
          handleSubmit,
          submitForm,
        }         = props;
  const { t }     = useTranslation();
  const { pages } = useCommon();

  const agreementPageUrl = useMemo(() => {
    const page = pages.find(page => page.template === 'policy-personal-data');

    return `/${page.urlKey}`;
  }, [pages]);

  return (
    <form
      name={'RegisterForm'}
      className={'RegisterForm'}
      noValidate={true}
      method={'post'}
      onSubmit={event => submitForm(event, handleSubmit)}
    >
      <fieldset>
        <RenderEmailField name={'email'} label={t('client_set_email')} />
        <RenderPasswordField name={'password'} label={t('client_set_password')} />
        <RenderPasswordField name={'passwordRepeat'} label={t('field_passwordRepeat')} />
        <RenderCheckboxField name={'confirmation'} label={<Agreement t={t} url={agreementPageUrl} />} />
      </fieldset>
      <div>
        <RenderButton type={'submit'} className={'fill'} label={t('btn_send')} />
        <RenderButton label={t('label_authorization')} action={() => changeTab(0)} />
      </div>
    </form>
  );
};

function Agreement(props) {
  const {
          t,
          url,
        } = props;

  return (
    <>
      {t('client_agreement.i_read')}
      <a href={url}>{t('client_agreement.user_contract')}</a> {t('client_agreement.i_agree')}
    </>
  );
}

export default reduxForm({
  form:     'RegisterForm',
  validate: (values) => {
    let errors = {};

    if (true !== values.confirmation) {
      errors.confirmation = i18n.t('client_confirmationValidate');
    }

    return errors;
  }
  ,
  onSubmitFail: (errors, dispatch) => {
  },
})(RegisterForm);